<script>



export default {

    methods : {
        loading : function(s){
            s == true ?
                this.showLoading = true
                :
                this.showLoading = false;
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/mixin/global.vue